import { render, staticRenderFns } from "./MailingListDependencyList.vue?vue&type=template&id=9f82877e&scoped=true"
import script from "./MailingListDependencyList.vue?vue&type=script&setup=true&lang=js"
export * from "./MailingListDependencyList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f82877e",
  null
  
)

export default component.exports